import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { IonDatetime, ModalController } from '@ionic/angular';
import { LOG_TYPE } from 'src/app/model/logger.model';
import { COMPONENT_NAME, DATE_TIME_FORMAT } from 'src/app/util/constants';
import { DateFunctions } from 'src/app/util/date-functions';
import { LoggerService } from '../../services/logger/logger.service';
import { BASE_CONFIG } from '../../util/base-settings';




@Component({
  selector: 'a24-range-date-picker',
  templateUrl: './range-date-picker.component.html',
  styleUrls: ['./range-date-picker.component.scss'],
})
export class RangeDatePickerComponent implements OnInit
{

  @Input() selStartDate: string = null;
  @Input() selEndDate: string = null;

  @Output() emittedDate = new EventEmitter<any>() ;
  @Input() maxDate : any = 2050 ;
  @Input() minDate : any = 2000 ; 
  @Input() pickerId : string = '' ;
  @Input() restrictEndDate: boolean = true;

  @ViewChild('datetime') datePicker: IonDatetime;

  isStartDateModal: boolean = true;
  activeLangCode: string;
  showDateModal: boolean = false;
  endMaxDate: string = null;

  readonly startDate: string = $localize`:@@rangeDatePicker-startDate:START DATE`;
  readonly endDate: string = $localize`:@@rangeDatePicker-endDate:END DATE`;
  readonly setStartDate: string = $localize`:@@rangeDatePicker-setStartDate:Set Start Date`;
  readonly setEndDate: string = $localize`:@@rangeDatePicker-setEndDate:Set End Date`;

  constructor(
    private logger: LoggerService,
    private modalController: ModalController,
    private dateFunctions: DateFunctions
  ) { }

  ngOnInit()
  {
    try
    {
      if (!this.selStartDate && !this.selEndDate)
      {
        let dateOfMonth = this.dateFunctions.getStartAndEndDateOfMonth(new Date());
        this.selStartDate = this.dateFunctions.formatDate(dateOfMonth.start,DATE_TIME_FORMAT.API_DATE_FORMAT1);
        this.selEndDate = this.dateFunctions.formatDate(dateOfMonth.end,DATE_TIME_FORMAT.API_DATE_FORMAT1);
      }
  
    }
    catch (err)
    {
      let body = this.logger.buildRequest(
        COMPONENT_NAME.RANGE_DATE_PICKER_COMPONENT,
        "error in ngOnInit",
        err.toString(),
        "ngOnInit",
        LOG_TYPE.ERROR
      );
      this.logger.log(body);
    }
  }

  onStartDatePicked(pPickedDates: string | string[])
  {
    try
    {
      if (BASE_CONFIG.IS_DEBUG) console.log("onStartDatePicked");

      this.isStartDateModal = false;
      this.selStartDate = pPickedDates as string;
      if (this.restrictEndDate) {
        const next3Months: string = this.dateFunctions.getNext3Months(this.selStartDate);
        this.endMaxDate = this.dateFunctions.formatDate(next3Months, DATE_TIME_FORMAT.API_DATE_FORMAT1) <= this.dateFunctions.formatDate(this.maxDate, DATE_TIME_FORMAT.API_DATE_FORMAT1) ? next3Months : this.maxDate;
        this.selEndDate = this.endMaxDate;
      }
      this.closeModal();
      this.showDateModal = true;
    }
    catch (err)
    {
      let body = this.logger.buildRequest(
        COMPONENT_NAME.RANGE_DATE_PICKER_COMPONENT,
        "error in onStartDatePicked",
        err.toString(),
        "onStartDatePicked",
        LOG_TYPE.ERROR
      );
      this.logger.log(body);
    }
  }

  async onEndDatePicked(pPickedDates: string | string[])
  {
    try
    {
      if (BASE_CONFIG.IS_DEBUG) console.log("onEndDatePicked");

      this.selEndDate = pPickedDates as string;

      if (this.selStartDate > this.selEndDate)
      {
        const temp = this.selStartDate;
        this.selStartDate = this.selEndDate;
        this.selEndDate = temp;
      }

      this.emittedDate.emit({ startDate: this.selStartDate, endDate: this.selEndDate });

      this.closeModal();
    }
    catch (err)
    {
      let body = this.logger.buildRequest(
        COMPONENT_NAME.RANGE_DATE_PICKER_COMPONENT,
        "error in onEndDatePicked",
        err.toString(),
        "onEndDatePicked",
        LOG_TYPE.ERROR
      );
      this.logger.log(body);
    }
  }

  async closeModal()
  {
    try
    {
      if (BASE_CONFIG.IS_DEBUG) console.log("closeModal");
      this.showDateModal = false;
      const modal = await this.modalController.getTop();

      if (modal)
      {
        await modal.dismiss();
      }
    }
    catch (err)
    {
      let body = this.logger.buildRequest(
        COMPONENT_NAME.RANGE_DATE_PICKER_COMPONENT,
        "error in closeModal",
        err.toString(),
        "closeModal",
        LOG_TYPE.ERROR
      );
      this.logger.log(body);
    }
  }

  openDateModal()
  {
    try {
      if(BASE_CONFIG.IS_DEBUG) console.log("openDateModal");
      this.isStartDateModal = true ;
    } catch (error) {
      let logRequest =  this.logger.buildRequest(
        COMPONENT_NAME.RANGE_DATE_PICKER_COMPONENT,
        "error in openDateModal",
        error.toString(),
        "openDateModal",
      );
      this.logger.log(logRequest)
    }
  }

  // onReset()
  // {
  //   try {
  //     if(BASE_CONFIG.IS_DEBUG) console.log("onReset");
  //     this.datePicker.reset();
  //   } catch (error) {
  //     this.util.logFunc('onReset', error, COMPONENT_NAME.RANGE_DATE_PICKER_COMPONENT);
  //   }
  // }
}
